export default __webpack_public_path__ + "static/media/Pool.f0cf2460.jpg";